import { observable, action } from 'mobx';
import moment from 'moment';
import { api } from '../services';

class NoticesStore {
  @observable notices = [];
  @observable carouselVisible = false;
  @observable unreadNotices = [];
  @observable carsHaving = [];
  @observable virtualLoading = false;
  @observable noticesCount = 0;
  @observable virtualNotices = [];
  @observable virtualPageBounds = {};
  @observable unreadFirstNotices = [];
  @observable imeisWithNotices = [];

  @action loadNoticesVirtual = ({ page, from } = {}) => {
    this.virtualLoading = true;
    if (page === 1) {
      // reset cache from
      this.virtualPageBounds = {};
    } else {
      // restore cached from
      from = (this.virtualPageBounds[page] || {}).from;
    }
    const p1 = api('getAllNotices');
    const p2 = api('getOverRPMFuelTheftGeofence', { size: 7, from });
    return Promise.all([p1, p2]).then(([{ notifications: notices }, { rows: overRPMFuelTheftGeofence, count: overRPMFuelTheftGeofenceCount }]) => {
      this.setWithNotices((notices || []).map(notice => notice.asset));
      if (from === undefined) {
        const noticesCount = notices.length;
        this.noticesCount = noticesCount + overRPMFuelTheftGeofenceCount;
      }
      overRPMFuelTheftGeofence = overRPMFuelTheftGeofence.map(event => ({ ...event, timestamp: event.createdAt }));
      let merged = [].concat(notices, overRPMFuelTheftGeofence).sort((a, b) => {
        return b.timestamp > a.timestamp ? 1 : -1;
      });
      if (from) {
        merged = merged.filter(event => event.timestamp < from);
      }
      merged = merged.slice(0, 7);
      this.virtualNotices = merged;
      if (page === 1) {
        this.unreadFirstNotices = this.virtualNotices.filter(notice => {
          let storedValue = window.localStorage.getItem(this.calcStorageKey(notice));
          if (storedValue === null) {
            return true;
          }
          storedValue = JSON.parse(storedValue);
          return !storedValue.hasOwnProperty('lastViewed');
        });
      } else {
        this.unreadFirstNotices = [];
      }

      const nextPage = page + 1;
      if (this.virtualPageBounds[nextPage] === undefined) {
        let timestamp = new Date().toISOString();
        if (this.virtualNotices.length > 0) {
          ({ timestamp } = this.virtualNotices.slice().pop());
        }
        this.virtualPageBounds[nextPage] = { from: timestamp };
      }
      this.virtualLoading = false;
      return Promise.resolve({ loaded: true });
    });
  };

  @action setWithNotices(imeisWithNotices) {
    this.imeisWithNotices = imeisWithNotices;
  }

  @action setNotices = notices => {
    this.notices = notices;
  };

  getNotices = () => {
    return this.notices;
  };

  @action setDismissed = notice => {
    const value = { lastDismissed: new Date().toISOString() };
    const keyStorage = this.calcStorageKey(notice);
    let storedValue = JSON.parse(window.localStorage.getItem(keyStorage) || '{}');
    storedValue = storedValue !== null ? { ...storedValue, ...value } : value;
    window.localStorage.setItem(keyStorage, JSON.stringify(storedValue));
    this.processDismissed();
  };

  @action setViewed = notice => {
    const value = { lastViewed: new Date().toISOString() };
    const keyStorage = this.calcStorageKey(notice);
    let storedValue = JSON.parse(window.localStorage.getItem(keyStorage) || '{}');
    storedValue = storedValue !== null ? { ...storedValue, ...value } : value;
    window.localStorage.setItem(keyStorage, JSON.stringify(storedValue));
  };

  @action processDismissed = () => {
    const unread = this.notices.filter(notice => {
      let storedValue = window.localStorage.getItem(this.calcStorageKey(notice));
      if (storedValue === null) {
        return true;
      }
      storedValue = JSON.parse(storedValue);
      return !storedValue.hasOwnProperty('lastDismissed');
    });
    this.unreadNotices = unread;
  };

  calcStorageKey = data => {
    const time = moment(data.timestamp).utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    return `io.myair.myfleet.notice.${data.asset}.${time}`;
  };

  @action setMultipleDismissedSamePlateType = ({ plate, type }) => {
    const dismissableTypeWhiteList = ['fuel-theft', 'rpm-over', 'geofenceInside', 'geofenceOutside'];
    if (dismissableTypeWhiteList.includes(type)) {
      api('noticesReadMany', { plate, type }).then(() => {
        this.loadNoticesVirtual({ page: 1 });
      });
    }
  };
}

export default new NoticesStore();



// WEBPACK FOOTER //
// ./src/stores/noticesStore.js